
export const FETCH_ALL_WAREHOUSE_STYLE_DETAILS_REQUEST = 'FETCH_ALL_WAREHOUSE_STYLE_DETAILS_REQUEST';
export const FETCH_ALL_WAREHOUSE_STYLE_DETAILS_SUCCESS = 'FETCH_ALL_WAREHOUSE_STYLE_DETAILS_SUCCESS';
export const FETCH_ALL_WAREHOUSE_STYLE_DETAILS_FAILURE = 'FETCH_ALL_WAREHOUSE_STYLE_DETAILS_FAILURE';

export const FETCH_ALL_PRODUCTS_STOCKS_REQUEST = 'FETCH_ALL_PRODUCTS_STOCKS_REQUEST';
export const FETCH_ALL_PRODUCTS_STOCKS_SUCCESS = 'FETCH_ALL_PRODUCTS_STOCKS_SUCCESS';
export const FETCH_ALL_PRODUCTS_STOCKS_FAILURE = 'FETCH_ALL_PRODUCTS_STOCKS_FAILURE';

export const FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_REQUEST = 'FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_REQUEST';
export const FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_SUCCESS = 'FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_SUCCESS';
export const FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_FAILURE = 'FETCH_BY_ID_WAREHOUSE_STYLE_DETAILS_FAILURE';

export const CREATE_USERFORM_WAREHOUSE_STYLE_DETAILS = 'CREATE_USERFORM_WAREHOUSE_STYLE_DETAILS';

export const CREATE_WAREHOUSE_STYLE_DETAILS_REQUEST = 'CREATE_WAREHOUSE_STYLE_DETAILS_REQUEST';
export const CREATE_WAREHOUSE_STYLE_DETAILS_SUCCESS = 'CREATE_WAREHOUSE_STYLE_DETAILS_SUCCESS';
export const CREATE_WAREHOUSE_STYLE_DETAILS_FAILURE = 'CREATE_WAREHOUSE_STYLE_DETAILS_FAILURE';

export const UPDATE_WAREHOUSE_STYLE_DETAILS_REQUEST = 'UPDATE_WAREHOUSE_STYLE_DETAILS_REQUEST';
export const UPDATE_WAREHOUSE_STYLE_DETAILS_SUCCESS = 'UPDATE_WAREHOUSE_STYLE_DETAILS_SUCCESS';
export const UPDATE_WAREHOUSE_STYLE_DETAILS_FAILURE = 'UPDATE_WAREHOUSE_STYLE_DETAILS_FAILURE';

export const DELETE_WAREHOUSE_STYLE_DETAILS_REQUEST = 'DELETE_WAREHOUSE_STYLE_DETAILS_REQUEST';
export const DELETE_WAREHOUSE_STYLE_DETAILS_SUCCESS = 'DELETE_WAREHOUSE_STYLE_DETAILS_SUCCESS';
export const DELETE_WAREHOUSE_STYLE_DETAILS_FAILURE = 'DELETE_WAREHOUSE_STYLE_DETAILS_FAILURE';

export const RESET_WAREHOUSE_STYLE_DETAILS_USERFORM = 'RESET_WAREHOUSE_STYLE_DETAILS_USERFORM';
